import * as moment from 'moment';
import i18n from '@/plugins/i18n';
import { BusinessProspectApplicationDetails } from './business-prospect-application-details';

export enum BusinessProspectPaymentStatus {
    Pending,
    PaidCorrectly,
    PaymentError,
}

export class BusinessProspect {
    public id: number = 0;
    public createdUtc?: moment.Moment;
    public projectId: number = 0;
    public projectName?: string;
    public pricingId: number = 0;
    public pricingName?: string;
    public businessTradeName?: string;
    public companyName?: string;
    public companyTaxCode?: string;
    public businessContactPhone?: string;
    public businessContactEmail?: string;
    public businessFrontPageContactAddress?: string;
    public companyAddress?: string;
    public businessActivityLocalizedName?: any;
    public userFullName?: string;
    public userEmail?: string;
    public userPhone?: string;
    public userNotificationLanguageCulture?: string;
    public tosAccepted: boolean = false;
    public paymentStatus: BusinessProspectPaymentStatus = BusinessProspectPaymentStatus.Pending;
    public paymentOrderId?: string;
    public applicationDetails: BusinessProspectApplicationDetails = new BusinessProspectApplicationDetails();

    public get created(): moment.Moment | null {
        return this.createdUtc
            ? this.createdUtc.local()
            : null;
    }

    public get businessActivityName(): string | null {
        let text = null;

        if (this.businessActivityLocalizedName) {
            const resource = this.businessActivityLocalizedName.find((l: any) => l.culture === i18n.locale)!.resource;
            text = resource[Object.keys(resource)[0]];
        }
        return text ? `${i18n.t(text).toString()}` : null;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            createdUtc: moment.utc(json.createdUtc),
            businessActivityLocalizedName: json.businessActivityLocalizedName ? JSON.parse(json.businessActivityLocalizedName) : null,
            applicationDetails: new BusinessProspectApplicationDetails(json.applicationDetails),
        });

        if (this.businessActivityLocalizedName) {
            this.businessActivityLocalizedName.forEach((name: any) => {
                i18n.mergeLocaleMessage(name.culture, name.resource);
            });
        }
    }

    public reset(): void {
        this.id = 0;
        this.paymentStatus = BusinessProspectPaymentStatus.Pending;
    }

    public toString(): string {
        return `<ul>
                    <li>ID: <strong>${this.id}</strong></li>
                    <li>Created: <strong>${i18n.d(this.created!.toDate(), 'long')}</strong></li>
                    <li>Project: <strong>${this.projectName}</strong></li>
                    <li>Pricing: <strong>${this.pricingName}</strong></li>
                    <li>BusinessTradeName: <strong>${this.businessTradeName}</strong></li>
                    <li>CompanyName: <strong>${this.companyName}</strong></li>
                    <li>CompanyTaxCode: <strong>${this.companyTaxCode}</strong></li>
                    <li>BusinessContactPhone: <strong>${this.businessContactPhone}</strong></li>
                    <li>BusinessContactEmail: <strong>${this.businessContactEmail}</strong></li>
                    <li>BusinessFrontPageContactAddress: <strong>${this.businessFrontPageContactAddress}</strong></li>
                    <li>CompanyAddress: <strong>${this.companyAddress}</strong></li>
                    <li>BusinessActivity: <strong>${this.businessActivityName}</strong></li>
                    <li><hr/></li>
                    <li>UserFullName: <strong>${this.userFullName}</strong></li>
                    <li>UserEmail: <strong>${this.userEmail}</strong></li>
                    <li>UserPhone: <strong>${this.userPhone}</strong></li>
                    <li><hr/></li>
                    <li>UserNotificationLanguageCulture: <strong>${this.userNotificationLanguageCulture}</strong></li>
                    <li>ApplicationDetailsName: <strong>${this.applicationDetails.name}</strong></li>
                    <li>ApplicationDetailsURL: <strong>${this.applicationDetails.url}</strong></li>
                </ul>`;
    }
}
